import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { useEventListener } from '@vueuse/core'
import { useRouter } from 'vue-router/composables'

import LButton from '@/components/core/Button.vue'
import OnboardingCard from '@/components/onboarding/OnboardingCard.vue'
import NewTripModal from '@/components/home/newTrip/NewTripModal.vue'
import JoinTripModal from '@/components/JoinTripModal.vue'
import { logEvent } from '@/utils/utility-manager'

export interface OnboardingScreenProps {
  showBackButton?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingScreen',
  props: {
    showBackButton: { type: Boolean, default: true }
  },
  emits: ['click:back'],
  setup(__props: any) {




const router = useRouter()

const onboardingJoinTripModal = ref<InstanceType<typeof JoinTripModal> | null>(
  null,
)

function toggleJoinTripModal() {
  if (onboardingJoinTripModal.value) {
    logEvent('trip_join_started', {
      context: 'onboarding_v3',
    })
    onboardingJoinTripModal.value.toggleDialog()
  }
}

async function navigateToAssistant() {
  logEvent('ai_assistant_viewed', {
    context: 'onboarding_v3',
    source: 'onboarding_screen',
  })

  await router.push({ path: '/get-started' })
}

async function navigateToDiscover() {
  logEvent('inspiration_search_started', {
    context: 'onboarding_v3',
  })

  await router.push({ path: '/discover' })
}

let windowHeight = 800

onMounted(() => {
  useEventListener('resize', () => {
    windowHeight = window.innerHeight
  })
})

return { __sfc: true,router, onboardingJoinTripModal, toggleJoinTripModal, navigateToAssistant, navigateToDiscover, windowHeight, LButton, OnboardingCard, NewTripModal, JoinTripModal }
}

})